import { Injectable } from '@angular/core';
import { Dictionary } from 'highcharts';
import { ApiClient } from '../http/api-client';

export interface AdminFee {
  id: string;
  vendorId: string;
  name: string | null; // joined in from the partners table
  amountCents?: number;
  appliesWhen?: Dictionary<any>;
  always?: boolean;
  stripeProductId?: string;
  vendorProductId?: string;
  cartLabel?: string;
  moreInfoHtml?: string;
  chargeMode?: 'bundled' | 'line_item' | string;
  amountRules?: Dictionary<any> | Array<Dictionary<any>>;
}

@Injectable({
  providedIn: 'root'
})

export class AdminFeesService {

  constructor(
    private restangular: ApiClient,
  ) {
  }

  createAdminFee(adminFeeData: Record<string, any>): Promise<{ id: string }> {
    return this.restangular.one('adminFees').customPOST(adminFeeData).toPromise() as Promise<{ id: string }>;
  }

  deleteAdminFee(adminFeeId: string): Promise<AdminFee> {
    return this.restangular.one('adminFees', adminFeeId).customDELETE().toPromise() as Promise<AdminFee>;
  }

  getAllAdminFees(): Promise<AdminFee[]> {
    return this.restangular.one('adminFees').getList().toPromise() as Promise<AdminFee[]>;
  }

  updateAdminFee(adminFeeId: string, adminFeeData: Record<string, any>): Promise<AdminFee[]> {
    return this.restangular.one('adminFees', adminFeeId).customPUT(adminFeeData).toPromise() as Promise<AdminFee[]>;
  }
}
